/**
 * created by song on 2020-01-16
 */
'use strict';
angular.module('autotypesetModule', []).controller('autotypesetCtrl', ['$scope', '$modalInstance', 'setparams',
    function($scope, $modalInstance, setparams) {
        initStatus();
        initData();

        /**
         * [initStatus description] 初始化函数
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            // var storage = setparams.editor.getPreferences('autotypeset');
            var storageOpt = setparams.opt;
            $scope.autotypesetGet = storageOpt ? storageOpt : angular.copy(window.UEDITOR_CONFIG.autotypeset);
            $scope.rememberMe = angular.copy(setparams.opt.REMEMBERME) || '0'; // 获取的-记住我
            $scope.status = {
                opt: $scope.autotypesetGet ? angular.copy($scope.autotypesetGet) : angular.copy(setparams.editor.options.autotypeset),
                remember: $scope.rememberMe || '0', // 记住我的选择
                editor: setparams.editor,
                fontsizenew: [],
                fontfamilynew: [],
                modaltitle: '一键排版设置',
                isValidOne: true,
                isValidTwo: true,
                isLineValid: true,
            };
        }

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            revertFontsize();
            revertFontfamilyname();
        }

        $scope.typesetcheck = function(item) {
            $scope.status.opt[item] = !$scope.status.opt[item];
        };

        /* 记住我的选择*/
        $scope.rememberMeFun = function() {
            $scope.status.remember = $scope.status.remember == '1' ? '0' : '1';
        };

        /**
         * [cancel description] 取消
         * @return  {[type]}  [return description]
         */
        $scope.cancel = function() {
            $modalInstance.dismiss();
        };

        /**
         * [confirm description] 确定
         * @return  {[type]}  [return description]
         */
        $scope.confirm = function() {
            if (!$scope.status.isValidOne || !$scope.status.isValidTwo || !$scope.status.isLineValid) {return;}
            $scope.status.editor.options.autotypeset = $scope.status.opt;
            $modalInstance.close($scope.status.opt);
        };

        /**
         * [revertFontsize description] 字号转换
         * @return  {[type]}  [return description]
         */
        function revertFontsize() {
            angular.forEach($scope.status.editor.options.fontsize, function(value, key) {
                var item = {
                    'name': $scope.status.editor.options.fontsizename[key],
                    'val': value + 'px',
                };
                $scope.status.fontsizenew.push(item);
            });
        }

        /**
         * [revertFontfamilyname description] 字体名称转换为中文
         * @return  {[type]}  [return description]
         */
        function revertFontfamilyname() {
            angular.forEach($scope.status.editor.options.fontfamily, function(value, key) {
                var item = {
                    'name': $scope.status.editor.getLang('fontfamily')[value.name] || value.label,
                    'val': value.val,
                };
                $scope.status.fontfamilynew.push(item);
            });
        }

        /* 符号转换*/
        $scope.tobdc = function() {
            if ($scope.status.opt.bdc2sb || $scope.status.opt.tobdc) {
                $scope.status.opt.bdc2sb = $scope.status.opt.tobdc = false;
            } else {
                $scope.status.opt.bdc2sb = true;
            }
        };

        $scope.switchTobdc = function (type) {
            if (type === 'bdc2sb') {
                $scope.status.opt.bdc2sb = !$scope.status.opt.bdc2sb;
                $scope.status.opt.tobdc = !$scope.status.opt.bdc2sb;
            } else {
                $scope.status.opt.tobdc = !$scope.status.opt.tobdc;
                $scope.status.opt.bdc2sb = !$scope.status.opt.tobdc;
            }
        }

        /* 重置配置*/
        $scope.reset = function() {
            $scope.status.opt = angular.copy(window.UEDITOR_CONFIG.autotypeset);
            $scope.status.opt.pasteFilter = true;
            $scope.status.opt.removeEmptyNode = true;
            if (setparams.media && setparams.media === 'app') {
                $scope.status.opt.textAlign = 'justify';
                $scope.status.opt.lineheight = {
                    flag: true,
                    val: '1.5'
                };
            }
            // $scope.status.opt = $scope.autotypesetGet ? angular.copy($scope.autotypesetGet) : angular.copy(setparams.editor.options.autotypeset)
        };

        $scope.checkinvalid = function(option, val, index) {
            var re = /^(\-|\+)?\d+(\.\d+)?$/;
            if (!re.test(val)) {
                option.val = '';
            }
            if (val > 100) {
                if (index == '1') {
                    $scope.status.isValidOne = false;
                    $('.auto-input1').css('border-color', '#d64541');
                } else {
                    $scope.status.isValidTwo = false;
                    $('.auto-input2').css('border-color', '#d64541');
                }

            } else {
                if (index == '1') {
                    $scope.status.isValidOne = true;
                    $('.auto-input1').css('border-color', '#ddd');
                } else {
                    $scope.status.isValidTwo = true;
                    $('.auto-input2').css('border-color', '#ddd');
                }
            }
        };
        $scope.checkinvalid2 = function(option, val) {
            var re = /^(([0-9]+[\.]?[0-9]+)|[1-9])$/;
            if (!re.test(val)) {
                option.val = '';
            }
            if (val > 20) {
                $('.auto-line-tips').show();
                $('.auto-line-input').css('border-color', '#d64541');
                $scope.status.isLineValid = false;
            } else {
                $('.auto-line-tips').hide();
                $('.auto-line-input').css('border-color', '#ddd');
                $scope.status.isLineValid = true;
            }
        };
    },
]);
